<template>
  <zm-drawer :title="title" :width="760" :visible="visible" @cancel="open(false)" :footer="false">
    <div slot="drawerBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
              <a-input disabled v-decorator="['userName', { rules: [{ required: true }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别">
              <a-input disabled v-decorator="['genderDesc', { rules: [{ required: true }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应聘岗位">
              <a-input disabled v-decorator="['departmentJobStr', { rules: [{ required: true }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属部门">
              <a-input disabled v-decorator="['applyDepartmentStr', { rules: [{ required: true }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实习岗">
              <a-switch
                size="small"
                disabled
                :checked="form.getFieldValue('internship')"
                style="margin: 2px 8px 6px 0"
                v-decorator="['internship', { rules: [{ required: true }] }]"
              />
              <span>{{ model.internship ? '是' : '否' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在职状态">
              <a-input disabled v-decorator="['workStatusDesc', { rules: [{ required: false }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最高学历">
              <a-input disabled v-decorator="['educationStr', { rules: [{ required: false }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="毕业院校">
              <a-input disabled v-decorator="['school', { rules: [{ required: false }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电子邮箱">
              <a-input disabled v-decorator="['email', { rules: [{ required: false }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
              <a-input disabled v-decorator="['tel', { rules: [{ required: true }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="目前年薪">
              <a-input
                style="width: calc(100% - 20px)"
                disabled
                v-decorator="['currentAnnualSalary', { rules: [{ required: false }] }]"
              />
              <span style="display: inline-block; width: 20px; text-align: right">元</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="期望年限">
              <a-input
                style="width: calc(100% - 20px)"
                disabled
                v-decorator="['itemAnnualSalary', { rules: [{ required: false }] }]"
              />
              <span style="display: inline-block; width: 20px; text-align: right">元</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="邀约平台">
              <a-input disabled v-decorator="['invitePlatformStr', { rules: [{ required: false }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试时间">
              <a-date-picker
                show-time
                format="YYYY-MM-DD HH:mm"
                style="width: 100%"
                disabled
                v-decorator="['planInterviewTime', { rules: [{ required: true }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试官">
              <a-input disabled v-decorator="['interviewerName', { rules: [{ required: true }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试状态">
              <a-input disabled v-decorator="['statusDesc', { rules: [{ required: false }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan" v-if="model.status > 1 && model.status < 7">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试评分">
              <a-input
                style="width: calc(100% - 20px)"
                disabled
                v-decorator="['interviewScore', { rules: [{ required: false }] }]"
              />
              <span style="display: inline-block; width: 20px; text-align: right">分</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="简历附件">
              <zm-preview
                :list="fileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/interviewee/file/"
              ></zm-preview>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="评分附件">
              <zm-preview
                :list="scoreFileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/interviewee/file/"
              ></zm-preview>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注">
              <a-textarea disabled :rows="3" v-decorator="['remark', { rules: [{ required: false }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>
<script>
import moment from 'moment'
import { getApplicationResult } from '@/api/applicant'

export default {
  name: 'viewApplicant',
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'applicant' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 },
      },
      colSpan: 12,

      fileList: [],
      scoreFileList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.$nextTick(() => {
          let statusDesc = ''
          switch (this.model.status) {
            case 1:
              statusDesc = '确认面试'
              break
            case 2:
              statusDesc = '面试通过'
              break
            case 3:
              statusDesc = '面试未通过'
              break
            case 4:
              statusDesc = '取消入职'
              break
            case 6:
              statusDesc = '已入职'
              break
            case 7:
              statusDesc = '取消面试'
              break
            default:
              statusDesc = '待面试'
          }
          const data = {
            userName: this.model.userName,
            genderDesc: this.model.gender == 1 ? '男' : this.model.gender == 2 ? '女' : '未设置',
            departmentJobStr: this.model.departmentJobStr,
            applyDepartmentStr: this.model.applyDepartmentStr,
            internship: !!this.model.internship,
            workStatusDesc: this.model.workStatus == 1 ? '待业' : '在职',
            educationStr: this.model.educationStr,
            school: this.model.school,
            email: this.model.email,
            tel: this.model.tel,
            currentAnnualSalary: this.model.currentAnnualSalary,
            itemAnnualSalary: this.model.itemAnnualSalary,
            invitePlatformStr: this.model.invitePlatformStr,
            planInterviewTime: moment(this.model.planInterviewTime, 'YYYY-MM-DD HH:mm'),
            interviewerName: this.model.interviewerName,
            statusDesc: statusDesc,
            remark: this.model.remark
          }
          this.form.setFieldsValue(data)
          this.fileList = this.model.fileList

          if (this.model.status > 1 && this.model.status < 7) {
            this.initResultInfo()
          }
        })
      } else {
        this.model = {}
      }
    },
    // 获取面试结果信息
    async initResultInfo () {
      const res = await getApplicationResult({ intervieweeId: this.model.id }).catch(() => {
        this.$message.error('获取面试结果失败！')
      })
      if (res && res.status === 0) {
        const data = res.data
        this.scoreFileList = data.fileList
        this.form.setFieldsValue({
          interviewScore: data.interviewScore,
          remark: this.model.status > 5 ? data.reason : data.remarks
        })
      }
    },
    // 清空表单
    formClear () {
      this.form.resetFields()

      this.fileList = []
      this.scoreFileList = []
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
  }
}
</script>

<style scoped lang="less">
// .ant-form-item {
//   .text,
//   .textArea {
//     border: 1px solid #e8e8e8;
//     border-radius: 4px;
//     padding: 0 10px;
//   }
// }
</style>
